/* WSS header behaviour (sections/wss-header.liquid): mega menus, sticky slim bar, phone drawer, basket count. Moved out of the section 16 Oct; loaded from snippets/stylesheets.liquid. */
(function () {
  function init() {
(function () {
  var root = document.querySelector('[data-wss-hd]');
  if (!root || root.__wss) return;
  root.__wss = true;
  var section = root.closest('.shopify-section') || root;
  var scrim = root.querySelector('[data-wss-hd-scrim]');
  var openId = null, tOpen = null, tClose = null, openedAt = 0;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  function trig(id) { return root.querySelector('[data-wss-hd-open="' + id + '"]'); }
  function panel(id) { return root.querySelector('[data-wss-hd-panel="' + id + '"]'); }
  function open(id) {
    clearTimeout(tClose); clearTimeout(tOpen);
    if (openId === id) return;
    if (openId) { panel(openId).hidden = true; trig(openId).setAttribute('aria-expanded', 'false'); }
    openId = id; openedAt = Date.now();
    var p = panel(id); if (!p) return;
    p.hidden = false; trig(id).setAttribute('aria-expanded', 'true');
    scrim.hidden = false; root.classList.add('is-open');
  }
  function close() {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!openId) return;
    panel(openId).hidden = true; trig(openId).setAttribute('aria-expanded', 'false');
    openId = null; scrim.hidden = true; root.classList.remove('is-open');
  }
  root.querySelectorAll('[data-wss-hd-open]').forEach(function (b) {
    var id = b.getAttribute('data-wss-hd-open');
    // A click straight after the hover has opened the menu keeps it open rather than closing it again.
    b.addEventListener('click', function () {
      if (openId !== id) return open(id);
      if (Date.now() - openedAt > 600) close();
    });
    if (fine) {
      b.addEventListener('pointerenter', function () {
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(id); }, openId ? 0 : 120);
      });
      b.addEventListener('pointerleave', function () { clearTimeout(tOpen); });
    }
  });
  if (fine) {
    var bar = root.querySelector('.wss-hd__bar');
    bar.addEventListener('pointerleave', function () { clearTimeout(tOpen); tClose = setTimeout(close, 250); });
    bar.addEventListener('pointerenter', function () { clearTimeout(tClose); });
    root.querySelectorAll('.wss-hd__item:not([data-wss-hd-open]), .wss-hd__right').forEach(function (el) {
      el.addEventListener('pointerenter', function () { clearTimeout(tOpen); tClose = setTimeout(close, 150); });
    });
  }
  // Menu photos load lazily; fetch them as soon as the shopper heads for the menu.
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    root.querySelectorAll('.wss-mega__promo img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  root.querySelector('.wss-hd__bar').addEventListener('pointerenter', warm);
  root.querySelector('.wss-hd__bar').addEventListener('focusin', warm);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openId) { var t = trig(openId); close(); if (t) t.focus(); }
  });
  document.addEventListener('focusin', function (e) { if (openId && !root.contains(e.target)) close(); });
  // A link click inside the menu closes it (the page is about to change).
  root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.wss-mega a')) close(); });

  // Once the bar reaches the top it sticks 20px up (see the stylesheet), so it's no longer fully on screen: slim it down.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { section.classList.toggle('wss-hd-stuck', e.intersectionRatio < 1 && e.boundingClientRect.top < 0); });
    }, { threshold: [1] }).observe(section);
  }

  // Mobile drawer: level 1 list, level 2 slides in from the right.
  var dr = root.querySelector('[data-wss-dr]');
  var drBtn = root.querySelector('[data-wss-dr-open]');
  if (dr && drBtn) {
    var mainV = dr.querySelector('[data-wss-dr-view="main"]');
    var curSub = null, lastGo = null, tHide = null;
    function lock(on) { document.documentElement.classList.toggle('wss-dr-lock', on); }
    function drOpen() {
      clearTimeout(tHide);
      dr.hidden = false; dr.offsetWidth; dr.classList.add('is-open');
      drBtn.setAttribute('aria-expanded', 'true'); lock(true);
      var x = dr.querySelector('.wss-dr__x'); if (x) x.focus({ preventScroll: true });
    }
    function drClose(noFocus) {
      if (dr.hidden) return;
      dr.classList.remove('is-open'); drBtn.setAttribute('aria-expanded', 'false'); lock(false);
      tHide = setTimeout(function () { dr.hidden = true; back(true); }, 320);
      if (!noFocus) drBtn.focus({ preventScroll: true });
    }
    function go(id, btn) {
      var v = dr.querySelector('[data-wss-dr-view="' + id + '"]'); if (!v) return;
      curSub = v; lastGo = btn; v.hidden = false; v.scrollTop = 0; v.offsetWidth;
      dr.classList.add('is-sub'); v.classList.add('is-in');
      setTimeout(function () { var bk = v.querySelector('[data-wss-dr-back]'); if (bk) bk.focus({ preventScroll: true }); }, 60);
    }
    function back(instant) {
      if (!curSub) return;
      var v = curSub; curSub = null;
      dr.classList.remove('is-sub'); v.classList.remove('is-in');
      if (instant) v.hidden = true; else setTimeout(function () { if (v !== curSub) v.hidden = true; }, 300);
      if (!instant && lastGo) lastGo.focus({ preventScroll: true });
    }
    drBtn.addEventListener('click', drOpen);
    dr.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentNode;
      var g = t.closest('[data-wss-dr-go]');
      if (g) return go(g.getAttribute('data-wss-dr-go'), g);
      if (t.closest('[data-wss-dr-back]')) return back();
      if (t.closest('[data-wss-dr-close]')) return drClose();
      if (t.closest('a[href]')) drClose(true);
    });
    dr.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); if (curSub) back(); else drClose(); return; }
      if (e.key !== 'Tab') return;
      var scope = dr.querySelector('.wss-dr__top');
      var area = curSub || mainV;
      var f = [].slice.call(scope.querySelectorAll('a[href],button')).concat([].slice.call(area.querySelectorAll('a[href],button')));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // Close if the screen is widened to desktop.
    if (window.matchMedia) {
      var mq = matchMedia('(min-width: 990px)');
      var onMq = function () { if (mq.matches) drClose(true); };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) { dr.classList.remove('is-open'); dr.hidden = true; back(true); lock(false); } });
  }

  // Basket count follows the cart.
  function setCount(n) {
    root.querySelectorAll('[data-wss-hd-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  var tc;
  function readCart() {
    clearTimeout(tc);
    tc = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count || 0); }).catch(function () {});
    }, 250);
  }
  ['cart:update', 'cart:updated', 'cart:change', 'cart:add'].forEach(function (ev) { document.addEventListener(ev, readCart); });
  // Horizon's header and basket drawer come later in the page, so hook into them once it has loaded.
  function watchCart() {
    // Horizon keeps its own (hidden on desktop) basket bubble up to date; mirror it.
    var hzActions = document.querySelector('header-actions');
    if (hzActions && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var t = document.querySelector('header-actions .cart-bubble__text-count');
        var n = t ? parseInt(t.textContent, 10) || 0 : null;
        if (n !== null) setCount(n); else readCart();
      }).observe(hzActions.closest('.shopify-section') || hzActions, { subtree: true, childList: true, characterData: true });
    }
    // The basket drawer re-renders whenever the cart changes (add, quantity, remove), so re-read then too.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(readCart).observe(drawer.closest('.shopify-section') || drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart); else watchCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });
})();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: the header section is re-rendered in place, so set it up again.
  document.addEventListener('shopify:section:load', init);
})();
